module.exports = __webpack_public_path__ + "static/media/document_icon.e5904aaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/document_icon.svg
// module id = 324
// module chunks = 21